import { z } from 'zod';
import { ConversationParticipant } from '../client';
import { makeEvent } from './EventBase';

export const ConversationParticipantAdded = makeEvent(
    'Conversation\\ConversationParticipantAdded',
    z.object({
        data: ConversationParticipant,
    }),
);

export type ConversationParticipantAdded = (typeof ConversationParticipantAdded)['schema']['_output'];
